import { captureMeasurementEntry } from './bullstory-measurement/source';
import {biteMeasurementPath} from './bite-measurement-path';
import { campaignFields } from '../../../config/bite-attribution.json';

// Only document memory until consent. Never a cookie, browser ID or storage write.
let entry = typeof window === 'undefined' ? null : captureMeasurementEntry();
if(entry)entry={...entry,path:biteMeasurementPath(window.location.pathname)};
let pendingClick: string | undefined;
let campaignSearch = '';
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  pendingClick = params.get('fbclid') || undefined;
  const campaign = new URLSearchParams();
  for (const key of campaignFields) if (params.has(key)) campaign.set(key, params.get(key)!);
  campaignSearch = campaign.toString();
}
let analyticsCleared = false;
let advertisingCleared = false;

export function biteAnalyticsEntry() {
  return analyticsCleared ? { source: 'direct', path: biteMeasurementPath(window.location.pathname) } : entry;
}
export function biteCampaignSearches() {
  const initial = campaignSearch;
  campaignSearch = '';
  return analyticsCleared ? [] : [initial, window.location.search];
}
export function biteAdvertisingClick() {
  if (advertisingCleared) return undefined;
  const current = new URLSearchParams(window.location.search).get('fbclid');
  if (current) pendingClick = current;
  return pendingClick;
}
export function clearBiteAdvertisingEntry() {
  pendingClick = undefined;
  advertisingCleared = true;
}
export function clearBiteAnalyticsEntry() {
  entry = null;
  campaignSearch = '';
  analyticsCleared = true;
}
